import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import moment from 'moment';
import { ConfirmDialogComponent } from '../../../core/components/confirm-dialog/confirm-dialog.component';
import { EditablePostClientStatus } from '../../../core/enums/editable-post-client-status';
import { MachineWorkDto } from '../../../core/models/machines/machine-work-dto';

@Injectable({
    providedIn: 'root'
})
export class MachineWorkHoursService {

    constructor(private dialog: MatDialog) { }

    public validate(workHours: MachineWorkDto[]): boolean {
        const activeHours = workHours.filter(r => r.clientStatus !== EditablePostClientStatus.Deleted);
        const today = moment().startOf('day');

        const hasActivePeriod = activeHours.some(r =>
            moment(r.from).startOf('day').isSameOrBefore(today) && !r.to
        );

        if (!hasActivePeriod) {
            this.dialog.open(ConfirmDialogComponent, {
                data: {
                    title: 'Arbetstimmar',
                    text: 'Gick inte att spara maskin. Minst en aktiv period (utan slutdatum) måste finnas för arbetstimmar.',
                    confirmButtonText: 'OK',
                }
            });
            return false;
        }

        return true;
    }

    public mapForUpdate(workHours: MachineWorkDto[]): MachineWorkDto[] {
        return workHours.map(workHour => ({
            id: workHour.id,
            tempId: workHour.tempId,
            clientStatus: workHour.clientStatus ?? (workHour.id ? EditablePostClientStatus.Updated : EditablePostClientStatus.New),
            from: workHour.from,
            to: workHour.to ?? null,
            hoursPerDay: workHour.hoursPerDay
        }));
    }
}
